import { type ImagesMap } from '@web-solutions/core/interfaces/images'

import GIFT_1X from './gift.webp'
import GIFT_2X from './gift@2x.webp'
import GIFT_3X from './gift@3x.webp'

export const IMAGES: ImagesMap = {
  GIFT: {
    src: GIFT_1X,
    srcSet: `${GIFT_1X}, ${GIFT_2X} 2x, ${GIFT_3X} 3x`
  }
}